import axios from 'axios'
import React from 'react'
import { render } from 'react-dom'
import { Provider } from 'react-redux'
import { ConnectedRouter } from 'react-router-redux'
// import { persistStore } from 'redux-persist'
// import { PersistGate } from 'redux-persist/es/integration/react'

import * as utils from './utils'
import './saltapi/enhancedAxios'
import SaltApi from './App'

import 'semantic-ui-css/semantic.min.css'


Promise.all([
  axios.get('/static/settings.json'),
  axios.get('/static/allArgspecsAndDocs.json')
]).then(([settings, allDocs]) => {
  if (process.env.NODE_ENV !== 'production') {
    return axios.get('/static/settings.local.json').then(
      devSettings => {
        return [settings.data, devSettings.data, allDocs.data]
      }).catch(() => [settings.data, {}, allDocs.data])
  }
  return [settings.data, {}, allDocs.data]
}).then(([ remoteSettings, devSettings, allDocs ]) => {
  // console.log(remoteSettings, devSettings, allDocs)
  return [{...remoteSettings, ...devSettings}, allDocs]
}).then(([remoteSettings, allDocs]) => {
  // console.log(remoteSettings, allDocs)
  const defaultSettings = utils.getDefaultSettings()
  const settings = {...defaultSettings, ...remoteSettings}
  const history = utils.getHistory()
  const store = utils.getStore(settings, allDocs)
  //const persistor = persistStore(store)
  //const SaltApi = utils.getConnectedApp(settings)
  // const saltApi = utils.getSaltApi(settings)
  // const SaltApi = require('./App').default

  if (process.env.NODE_ENV !== 'production') {
    require('dotenv').config()
    window.axios = axios
    window.React = React
    window.ReactDOM = require('react-dom').default
    window.store = store
    // window.persistor = persistor
    window.saltApi = utils.getSaltApi(settings)
    //window.saltApi = utils.getConnectedApp(settings)
    window.settings = settings
    window._history = history
    window.moment = require('moment')
  }


  const Root = (props) => {
    // console.log('Root: ', this.displayName, props)
    return (
      <Provider store={store}>
        {/*<PersistGate persistor={persistor}>*/}
        <ConnectedRouter history={history}>
          <SaltApi settings={settings} />
        </ConnectedRouter>
        {/*</PersistGate>*/}
      </Provider>
    )}
  Root.displayName = 'SaltReact'
  return Root
}).then(Root => render(<Root/>, document.getElementById('root')))

if (process.env.NODE_ENV !== 'production') {
  require('./registerServiceWorker').default()
}



// WEBPACK FOOTER //
// ./src/index.js